import React, { useRef, useEffect, useState } from "react";
import makeStyles from "@mui/styles/makeStyles";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Paper from "@mui/material/Paper";
import { createTheme } from "@mui/material";
import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import axios from "axios";
import { format, parseISO } from "date-fns";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import LinearProgress from "@mui/material/LinearProgress";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import MobileDatePicker from "@mui/lab/MobileDatePicker";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";

const drawerWidth = 300;

const materialTheme = createTheme({
  // set default for now
});

const useStyles = makeStyles((theme) => ({
  appBarSpacer: theme.mixins.toolbar,
  appBar: {
    position: "fixed",
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  appBarBottom: {
    top: "auto",
    bottom: 0,
    padding: 10,
    background: "white",
    boxShadow: "none",
    [theme.breakpoints.up("sm")]: {},
  },
  grow: {
    flexGrow: 1,
  },
  leftLabel: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  rightLabel: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const salesmanDialog = (
  openSalesmanDialog,
  setOpenSalesmanDialog,
  salesmans,
  setSelectedSalesman
) => {
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={materialTheme}>
        <Dialog
          fullWidth={true}
          maxWidth="md"
          aria-labelledby="confirmation-dialog-title"
          open={openSalesmanDialog}
          TransitionProps={{
            onEntering: () => {},
          }}
        >
          <DialogTitle id="confirmation-dialog-title">Select Salesman</DialogTitle>
          <DialogContent dividers>
            <List>
              {salesmans.map((salesman, index) => {
                return (
                  <ListItem
                    key={index + 1}
                    divider
                    button
                    onClick={() => {
                      setSelectedSalesman(salesman);
                      setOpenSalesmanDialog(false);
                    }}
                  >
                    <Typography variant="h6" component="h2">
                      {salesman.first_name} {salesman.last_name}
                    </Typography>
                  </ListItem>
                );
              })}
            </List>
          </DialogContent>
          <DialogActions>
            <Button
              autoFocus
              onClick={() => {
                setOpenSalesmanDialog(false);
              }}
              color="primary"
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </ThemeProvider>
    </StyledEngineProvider>
  );
};

function InvoiceInformationReview(props) {
  const classes = useStyles();
  const [errorMessage, setErrorMessage] = useState("");
  const [severityType, setSeverityType] = useState("");
  const [bluetoothConnection, setBluetoothConnection] = useState(false);
  const [characteristic, setCharacteristic] = useState(null);
  const [toPrintInvoiceInfo, setToPrintInvoiceInfo] = useState(null);
  const [selectedInvoiceDate, setSelectedInvoiceDate] = React.useState(new Date());
  const [scheduleDeliveryDate, setScheduleDeliveryDate] = React.useState(new Date());
  const [isInvoiceCalendarOpen, setIsInvoiceCalendarOpen] = useState(false);
  const [isDeliverySchedCalendarOpen, setIsDeliverySchedCalendarOpen] = useState(false);
  const [isSavingTransaction, setIsSavingTransaction] = useState(false);
  const [isSavingTransactionSuccess, setIsSavingTransactionSuccess] = useState(false);
  const [totalInvoicedAmount, setTotalInvoicedAmount] = useState(0);
  const [invoicedItemUomCount, setInvoicedItemUomCount] = useState(0);
  const [showMessageDialog, setShowMessageDialog] = useState(false);
  const [messageDialogMessage, setMessageDialogMessage] = useState("");
  const [openSalesmanDialog, setOpenSalesmanDialog] = useState(false);
  const [selectedSalesman, setSelectedSalesman] = useState(null);
  const [salesmans, setSalesmans] = useState([]);
  const [isFecthingSalesman, setIsFecthingSalesman] = useState(true);
  const [invoceInformation, setInvoiceInformation] = useState({
    invoice_number: "",
    invoice_date: format(new Date(), "yyyy-MM-dd"),
    scheduled_delivery_date: format(new Date(), "yyyy-MM-dd"),
    account_name: "",
    account_code: "",
    account_id: "",
    salesman_auto_generated_unique_id: "",
    salesman_first_name: "",
    salesman_last_name: "",
    salesman_middle_name: "",
    invoiced_items: [],
  });

  //Auto Generated Invoice Number Settings
  const [autoGeneratedInvoiceNumber, setAutoGeneratedInvoiceNumber] = useState("");

  const invoiceNumberInputOnChange = (event) => {
    const invoceInformationCopy = { ...invoceInformation };
    invoceInformationCopy.invoice_number = event.target.value;
    setInvoiceInformation(invoceInformationCopy);
  };

  const invoiceDateHandleDateChange = (date) => {
    const invoceInformationCopy = { ...invoceInformation };
    invoceInformationCopy.invoice_date = format(date, "yyyy-MM-dd");
    setInvoiceInformation(invoceInformationCopy);
    setSelectedInvoiceDate(date);
  };
  const scheduleDeliveryDateHandleDateChange = (date) => {
    const invoceInformationCopy = { ...invoceInformation };
    invoceInformationCopy.scheduled_delivery_date = format(date, "yyyy-MM-dd");

    setScheduleDeliveryDate(date);
  };

  function formatDate(dateString) {
    try {
      return format(parseISO(dateString), "yyyy-MM-dd");
    } catch (err) {
      return "";
    }
  }
  function computeOverallTotalInvoiceAmount() {
    const temporarySalesInvoiceString = localStorage.getItem(
      props.selectedAccount.auto_generated_id + "_temporary_sales_invoice"
    );
    if (temporarySalesInvoiceString == null) {
      return 0;
    }
    const temporarySaleInvoiced = JSON.parse(temporarySalesInvoiceString);
    const overallTotalAmount = temporarySaleInvoiced
      .reduce(
        (partialSum, product) => partialSum + computeTotalInvoiceAmountPerProduct(product),
        0.0
      )
      .toFixed(2);

    return overallTotalAmount;
  }

  function computeTotalInvoiceAmountPerProduct(product) {
    const totalInvoiceValue = Number(
      product.Units.reduce((partialSum, unit) => {
        const price =
          unit.new_price_with_tax === null ? unit.current_price_with_tax : unit.new_price_with_tax;
        const amount = parseFloat(unit.order_quantity) * price;
        return partialSum + (isNaN(amount) ? 0 : amount);
      }, 0.0)
    );
    return isNaN(totalInvoiceValue) ? 0 : totalInvoiceValue;
  }

  function getTotalNumberOfLines() {
    const temporarySalesInvoiceString = localStorage.getItem(
      props.selectedAccount.auto_generated_id + "_temporary_sales_invoice"
    );
    if (temporarySalesInvoiceString == null) {
      return 0;
    }
    const temporarySaleInvoiced = JSON.parse(temporarySalesInvoiceString);
    const totalLines = temporarySaleInvoiced.reduce((partialSum, product) => {
      const partianLines = product.Units.reduce((partialUnitSum, unit) => {
        let price =
          unit.new_price_with_tax === null ? unit.current_price_with_tax : unit.new_price_with_tax;

        if (unit.order_quantity > 0 && price > 0) {
          return partialUnitSum + 1;
        }
        return partialUnitSum;
      }, 0);
      return partialSum + partianLines;
    }, 0);

    return totalLines;
  }

  function getInvoicedItems() {
    const temporarySalesInvoiceString = localStorage.getItem(
      props.selectedAccount.auto_generated_id + "_temporary_sales_invoice"
    );
    if (temporarySalesInvoiceString == null) {
      return [];
    }

    const invoicedItems = [];
    const temporarySaleInvoiced = JSON.parse(temporarySalesInvoiceString);

    temporarySaleInvoiced.forEach((product) => {
      product.Units.forEach((unit) => {
        const price =
          unit.new_price_with_tax === null ? unit.current_price_with_tax : unit.new_price_with_tax;

        if (unit.order_quantity <= 0 || price <= 0) {
          return;
        }
        if (unit.order_quantity == null || price == null) {
          return;
        }

        const invoicedItem = {
          product_code: product.code,
          quantity_invoiced: unit.order_quantity,
          price_with_tax: price,
          price_without_tax: unit.price_without_tax,
          uom: unit.uom,
          product_name: product.name,
          // product_name: product.description
        };

        invoicedItems.push(invoicedItem);
      });
    });
    return invoicedItems;
  }

  function getInvoicedLotNumberAndExpirationPerProductPerUOM() {
    const invoicedLotNumberAndExpirationPerProductPerUOMs = [];

    const tempInvoicedLotNumberAndExpirationString = localStorage.getItem(
      props.selectedAccount.auto_generated_id + "_temp_invoiced_lot_number_and_expiration"
    );
    if (tempInvoicedLotNumberAndExpirationString == null) {
      return invoicedLotNumberAndExpirationPerProductPerUOMs;
    }

    const tempInvoicedLotNumberAndExpirationJSON = JSON.parse(
      tempInvoicedLotNumberAndExpirationString
    );

    tempInvoicedLotNumberAndExpirationJSON.forEach((data) => {
      const expirationDate = formatDate(data.expiration_date);
      const lotNumber = data.lot_number;
      const productCode = data.product_code;
      const invoicedQuantity = data.invoiced_quantity;
      const unit = data.unit;
      invoicedLotNumberAndExpirationPerProductPerUOMs.push({
        expirations: expirationDate,
        lot_number: lotNumber,
        product_code: productCode,
        uom: unit,
        quantity: invoicedQuantity,
      });
    });

    return invoicedLotNumberAndExpirationPerProductPerUOMs;
  }

  function getTotalInvoicedLotNumberAndExpirationInSmallestUom() {
    const totalInvoicedLotNumberAndExpirations = [];

    const tempInvoicedLotNumberAndExpirationString = localStorage.getItem(
      props.selectedAccount.auto_generated_id + "_temp_invoiced_lot_number_and_expiration"
    );
    if (tempInvoicedLotNumberAndExpirationString == null) {
      return totalInvoicedLotNumberAndExpirations;
    }

    const tempInvoicedLotNumberAndExpirationJSON = JSON.parse(
      tempInvoicedLotNumberAndExpirationString
    );

    tempInvoicedLotNumberAndExpirationJSON.forEach((data) => {
      const expirationDate = formatDate(data.expiration_date);
      const lotNumber = data.lot_number;
      const productCode = data.product_code;
      const invoicedQuantityInSmallestUom = data.invoiced_quantity_in_smallest_uom;

      const index = totalInvoicedLotNumberAndExpirations.findIndex((lotNumberAndExpiration) => {
        return (
          lotNumberAndExpiration.lot_number == lotNumber &&
          lotNumberAndExpiration.product_code == productCode &&
          formatDate(lotNumberAndExpiration.expiration_date) == expirationDate
        );
      });

      if (index < 0) {
        // INSERT
        const invoicedLotNumAndExpirationDateObject = {
          product_code: productCode,
          lot_number: lotNumber,
          expiration_date: expirationDate,
          invoiced_quantity_in_smallest_uom: invoicedQuantityInSmallestUom,
        };
        totalInvoicedLotNumberAndExpirations.push(invoicedLotNumAndExpirationDateObject);
      } else {
        //UPDATE quantity

        const totalInvoicedLotNumberAndExpiration = totalInvoicedLotNumberAndExpirations[index];
        totalInvoicedLotNumberAndExpiration.invoiced_quantity_in_smallest_uom =
          totalInvoicedLotNumberAndExpiration.invoiced_quantity_in_smallest_uom +
          invoicedQuantityInSmallestUom;
        totalInvoicedLotNumberAndExpirations.splice(index, 1, totalInvoicedLotNumberAndExpiration);
      }
    });

    return totalInvoicedLotNumberAndExpirations;
  }

  function progressDialog() {
    return (
      <Dialog fullWidth={true} maxWidth={"lg"} open={isSavingTransaction} onClose={() => {}}>
        <DialogContent>
          <DialogContentText>Saving invoice... Please wait...</DialogContentText>
          <LinearProgress color="secondary" />
        </DialogContent>
      </Dialog>
    );
  }
  function messageDialog() {
    return (
      <Dialog
        fullWidth={true}
        maxWidth={"sm"}
        open={showMessageDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Message"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {messageDialogMessage}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              handleBluetoothConnection();
            }}
            color="primary"
            autoFocus
          >
            CONNECT BLUETOOTH
          </Button>

          <Button
            onClick={() => {
              printData();
            }}
            color="primary"
            autoFocus
          >
            Print
          </Button>

          <Button
            onClick={() => {
              setShowMessageDialog(false);
              if (isSavingTransactionSuccess == true) {
                props.closeAllDialog();
                props.setReloadAccounts(true);
              }
            }}
            color="primary"
            autoFocus
          >
            Close
          </Button>
        </DialogActions>

        <SnackbarAlert open={bluetoothConnection} message={errorMessage} severity={severityType} />
      </Dialog>
    );
  }

  const objectToFormData = (object) =>
    Object.keys(object).reduce((formData, key) => {
      if (
        key == "invoiced_items" ||
        key == "total_invoiced_number_and_expiration_in_smallest_uom" ||
        key == "invoiced_lot_number_and_expirations"
      ) {
        object[key].forEach((order) => {
          formData.append(key, JSON.stringify(object[key]));
        });
      } else {
        formData.append(key, object[key]);
      }

      return formData;
    }, new FormData());

  function saveInvoice() {
    const invoceInformationCopy = { ...invoceInformation };
    invoceInformationCopy.account_code = props.selectedAccount.account_code;
    invoceInformationCopy.account_name = props.selectedAccount.account_name;
    invoceInformationCopy.account_id = props.selectedAccount.auto_generated_id;
    invoceInformationCopy.scheduled_delivery_date = formatDateToYmd(scheduleDeliveryDate);
    invoceInformationCopy.invoiced_items = getInvoicedItems();
    invoceInformationCopy.total_invoiced_number_and_expiration_in_smallest_uom =
      getTotalInvoicedLotNumberAndExpirationInSmallestUom();
    invoceInformationCopy.invoiced_lot_number_and_expirations =
      getInvoicedLotNumberAndExpirationPerProductPerUOM();
    invoceInformationCopy.salesman =
      selectedSalesman == null ? {} : JSON.stringify(selectedSalesman);

    if (selectedSalesman != null) {
      invoceInformationCopy.salesman_auto_generated_unique_id =
        selectedSalesman.auto_generated_unique_id === undefined
          ? ""
          : selectedSalesman.auto_generated_unique_id;
      invoceInformationCopy.salesman_first_name = selectedSalesman.first_name;
      invoceInformationCopy.salesman_last_name = selectedSalesman.last_name;
      invoceInformationCopy.salesman_middle_name = selectedSalesman.middle_name;
    }

    setIsSavingTransaction(true);

    setToPrintInvoiceInfo(invoceInformationCopy);
    const options = {
      method: "POST",
      url: "/TransactiInvoiceInformations/save.json",
      data: objectToFormData(invoceInformationCopy),
    };
    axios(options)
      .then((res) => {
        const isSuccess = res.data.response.is_success;
        if (!isSuccess) {
          setIsSavingTransactionSuccess(false);
          setIsSavingTransaction(false);
          setMessageDialogMessage(res.data.response.message);
          setShowMessageDialog(true);

          return;
        }

        localStorage.removeItem(
          props.selectedAccount.auto_generated_id + "_temporary_sales_invoice"
        );
        localStorage.removeItem(
          props.selectedAccount.auto_generated_id + "_temp_invoiced_lot_number_and_expiration"
        );

        setIsSavingTransactionSuccess(true);
        setIsSavingTransaction(false);
        setMessageDialogMessage("Transaction save successfully.");
        setShowMessageDialog(true);
      })
      .catch((error) => {
        setIsSavingTransactionSuccess(false);
        setIsSavingTransaction(false);
        setMessageDialogMessage("Failed to save invoice. Please try again.");
        setShowMessageDialog(true);
      });
  }

  const formatDateToYmd = (date_params) => {
    const date = new Date(date_params);

    // Get year, month, and date components from the date object
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based, so add 1
    const day = String(date.getDate()).padStart(2, "0");

    // Format the date into YYYY-MM-DD format
    const formattedDate = `${year}-${month}-${day}`;

    return formattedDate;
  };

  const handleBluetoothConnection = async () => {
    navigator.bluetooth.getAvailability().then((available) => {
      if (!available) {
        setErrorMessage("Bluetooth is not supported in this browser");
        setBluetoothConnection(true);
        setSeverityType("error");
        return;
      }
    });

    try {
      const options = { acceptAllDevices: true };

      const device = await navigator.bluetooth.requestDevice({
        filters: [{ services: ["000018f0-0000-1000-8000-00805f9b34fb"] }],
      });

      console.log(device);

      const server = await device.gatt.connect();
      console.log(server);

      const service = await server.getPrimaryService("000018f0-0000-1000-8000-00805f9b34fb");
      console.log("Service:", service);

      // Get the characteristic for writing data to the printer
      const characteristic = await service.getCharacteristic(
        "00002af1-0000-1000-8000-00805f9b34fb"
      );
      console.log("Characteristic:", characteristic);

      setErrorMessage("Bluetooth successfully connected");
      setBluetoothConnection(true);
      setSeverityType("success");
      setCharacteristic(characteristic);
      return;
    } catch (error) {
      console.error(error);
    }
  };

  const printData = async () => {
    try {
      await printAccountInformation();
      await delay(1000);
      await printItems();
    } catch (error) {
      setErrorMessage("Bluetooth is not connected");
      setSeverityType("error");
      setBluetoothConnection(true);
      console.error("Error checking Bluetooth connection:", error);
    }
  };

  const delay = (ms) => {
    return new Promise((resolve) => setTimeout(resolve, ms));
  };

  const printAccountInformation = async () => {
    if (typeof toPrintInvoiceInfo !== "undefined") {
      // Write a command to the printer to reset the text alignment
      const resetAlignment = new Uint8Array([0x1b, 0x61, 0x00]); // ESC a 0x00 - reset alignment

      // Account Name
      const account_name = "Account Name: " + toPrintInvoiceInfo.account_name + "\r\n";
      const account_data = new TextEncoder().encode(account_name);
      await characteristic.writeValue(account_data);
      const command = new Uint8Array([0x1b, 0x61, 0x02]); // ESC a 0x02 - right alignment
      await characteristic.writeValue(command);
      await characteristic.writeValue(resetAlignment); // write reset alignment

      // Account Code
      const account_code = "Account Code: " + toPrintInvoiceInfo.account_code + "\r\n";
      const account_code_data = new TextEncoder().encode(account_code);
      await characteristic.writeValue(account_code_data);
      const account_code_command = new Uint8Array([0x1b, 0x61, 0x02]); // ESC a 0x02 - right alignment
      await characteristic.writeValue(account_code_command);
      await characteristic.writeValue(resetAlignment); // write reset alignment

      // Invoice Value
      const total_amount =
        "Invoice Value: " +
        Number(totalInvoicedAmount).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }) +
        "\r\n";
      const total_amount_data = new TextEncoder().encode(total_amount);
      await characteristic.writeValue(total_amount_data);
      const total_amount_command = new Uint8Array([0x1b, 0x61, 0x02]); // ESC a 0x02 - right alignment
      await characteristic.writeValue(total_amount_command);
      await characteristic.writeValue(resetAlignment); // write reset alignment

      // INVOICE DATE
      const po_date = "Invoice Date: " + formatDateCopy(toPrintInvoiceInfo.invoice_date) + "\r\n";
      const po_date_data = new TextEncoder().encode(po_date);

      // Check if your printer supports right alignment
      const supportsRightAlignment = true; // Change this to the appropriate check for your printer

      if (supportsRightAlignment) {
        const po_date_command_right = new Uint8Array([27, 97, 2]); // ESC a 0x02 - right alignment
        await characteristic.writeValue(po_date_command_right);
      }

      await characteristic.writeValue(po_date_data);

      // Reset alignment (optional)
      const po_date_command_left = new Uint8Array([27, 97, 0]); // ESC a 0x00 - left alignment
      await characteristic.writeValue(po_date_command_left);

      // SCHEDULED DELIVERY DATE
      const created_date =
        "Scheduled Delivery Date: " +
        formatDateCopy(toPrintInvoiceInfo.scheduled_delivery_date) +
        "\r\n";
      const created_date_data = new TextEncoder().encode(created_date);

      if (supportsRightAlignment) {
        const created_date_command_right = new Uint8Array([27, 97, 2]); // ESC a 0x02 - right alignment
        await characteristic.writeValue(created_date_command_right);
      }

      await characteristic.writeValue(created_date_data);

      // Reset alignment (optional)
      const created_date_command_left = new Uint8Array([27, 97, 0]); // ESC a 0x00 - left alignment
      await characteristic.writeValue(created_date_command_left);

      const divider = "********************************\r\n";
      const divideData = new TextEncoder().encode(divider);
      await characteristic.writeValue(divideData);
      const centerCommand = new Uint8Array([0x1b, 0x61, 0x01]); // ESC a 0x01 - center alignment
      await characteristic.writeValue(centerCommand);
    }
  };

  const printItems = async () => {
    // Write a command to the printer to reset the text alignment
    const resetAlignment = new Uint8Array([0x1b, 0x61, 0x00]); // ESC a 0x00 - reset alignment

    // Spaces
    const spaces = "\r\n\r\n";
    const spaces_data = new TextEncoder().encode(spaces);
    await characteristic.writeValue(spaces_data);
    const command4 = new Uint8Array([0x1b, 0x61, 0x02]); // ESC a 0x02 - right alignment
    await characteristic.writeValue(command4);
    await characteristic.writeValue(resetAlignment);

    for (const items of toPrintInvoiceInfo.invoiced_items) {
      await printProductElements(items);
    }

    const divider = "********************************\r\n";
    const divideData = new TextEncoder().encode(divider);
    await characteristic.writeValue(divideData);
    const centerCommand = new Uint8Array([0x1b, 0x61, 0x01]); // ESC a 0x01 - center alignment
    await characteristic.writeValue(centerCommand);

    const computedAmount = computeTotalSalesOrderAmount();
    const total = "Total: " + computedAmount + "\r\n";
    const total_data = new TextEncoder().encode(total);
    await characteristic.writeValue(resetAlignment);
    await characteristic.writeValue(total_data);
    const command5 = new Uint8Array([0x1b, 0x61, 0x02]); // ESC a 0x02 - right alignment
    await characteristic.writeValue(command5);
    await characteristic.writeValue(resetAlignment);
  };

  const computeTotalSalesOrderAmount = () => {
    if (
      toPrintInvoiceInfo.invoiced_items === null ||
      toPrintInvoiceInfo.invoiced_items === undefined
    ) {
      return;
    }

    const totalInvoicedValue = Number(
      toPrintInvoiceInfo.invoiced_items.reduce((partialSum, product) => {
        // Parse price_with_tax to a floating-point number
        const priceWithTax = parseFloat(product.price_with_tax);

        // Check if the parsed value is a valid number
        if (isNaN(priceWithTax)) {
          console.error("Invalid price_with_tax:", product.price_with_tax);
          return partialSum; // Ignore invalid value and return current partial sum
        }

        // Parse quantity_invoiced to a floating-point number
        const quantityInvoiced = parseFloat(product.quantity_invoiced);

        // Calculate the partial sum for the current product
        const productTotal = priceWithTax * quantityInvoiced;

        return partialSum + productTotal;
      }, 0)
    );

    return totalInvoicedValue;
  };

  const printProductElements = async (product) => {
    // Write a command to the printer to reset the text alignment
    const resetAlignment = new Uint8Array([0x1b, 0x61, 0x00]); // ESC a 0x00 - reset alignment

    const product_name =
      product.product_name !== undefined ? product.product_name + "\r\n" : "NO PRODUCT NAME\r\n";
    const product_name_data = new TextEncoder().encode(product_name);
    await characteristic.writeValue(resetAlignment);
    await characteristic.writeValue(product_name_data);
    const command2 = new Uint8Array([0x1b, 0x61, 0x02]); // ESC a 0x02 - right alignment
    await characteristic.writeValue(command2);
    await characteristic.writeValue(resetAlignment);

    await delay(1000);

    const product_code =
      product.product_code !== undefined ? product.product_code + "\r\n" : "NO PRODUCT CODE\r\n";
    const product_code_data = new TextEncoder().encode(product_code);
    await characteristic.writeValue(resetAlignment);
    await characteristic.writeValue(product_code_data);
    const product_code_command2 = new Uint8Array([0x1b, 0x61, 0x02]); // ESC a 0x02 - right alignment
    await characteristic.writeValue(command2);
    await characteristic.writeValue(resetAlignment);

    await delay(1000);

    const computation =
      product.price_with_tax +
      " x " +
      product.quantity_invoiced +
      " " +
      product.uom +
      " = " +
      Number((product.price_with_tax * product.quantity_invoiced).toFixed(2)).toLocaleString(
        "en-US",
        { maximumFractionDigits: 2 }
      ) +
      "\r\n";
    const computation_data = new TextEncoder().encode(computation);
    await characteristic.writeValue(computation_data);
    const command3 = new Uint8Array([0x1b, 0x61, 0x02]); // ESC a 0x02 - right alignment
    await characteristic.writeValue(command3);
    await characteristic.writeValue(resetAlignment);

    await delay(1000);

    const spaces = "\r\n\r\n";
    const spaces_data = new TextEncoder().encode(spaces);
    await characteristic.writeValue(spaces_data);
    const command4 = new Uint8Array([0x1b, 0x61, 0x02]); // ESC a 0x02 - right alignment
    await characteristic.writeValue(command4);
    await characteristic.writeValue(resetAlignment);
  };

  const formatDateCopy = (dateStr) => {
    const dateString = dateStr;
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Add leading zero if necessary
    const day = String(date.getDate()).padStart(2, "0"); // Add leading zero if necessary
    const options = {
      year: "numeric",
      month: "long",
      day: "2-digit",
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    };
    const formattedDate = date.toLocaleTimeString("en-US", options);
    return formattedDate;
  };

  const SnackbarAlert = ({ open, message, severity }) => {
    return (
      <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {message != undefined ? message : ""}
        </Alert>
      </Snackbar>
    );
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setBluetoothConnection(false);
  };

  useEffect(() => {
    if (props.openInvoiceInformationReviewDialog == false) {
      return;
    }

    setTotalInvoicedAmount(computeOverallTotalInvoiceAmount());
    getAccountSalesman();
    getSettingsForAutoGeneratingInvoiceNumber();
  }, [props.openInvoiceInformationReviewDialog]);

  function getAccountSalesman(searchTerm) {
    const options = {
      method: "POST",
      url: "/TransactiSalesman/getAccountSalesman.json",
      data: objectToFormData({ search_term: searchTerm }),
    };
    axios(options)
      .then((res) => {
        const isSuccess = res.data.response.is_success;

        if (!isSuccess) {
          alert("Error encounter");
          return;
        }

        setSalesmans(res.data.response.Salesmans);

        setIsFecthingSalesman(false);
      })
      .catch((error) => {
        alert("Error encounter");
        console.log(error);
      });
  }

  const getSettingsForAutoGeneratingInvoiceNumber = () => {
    const options = {
      method: "POST",
      url: "/TransactiLiteGeneralSettings/fetchAutoGeneratedInvoiceNumber.json",
    };
    axios(options)
      .then((res) => {
        const { has_settings, auto_generated_invoice_number, is_success, message } =
          res.data.response;

        if (has_settings) {
          setAutoGeneratedInvoiceNumber(auto_generated_invoice_number);
          const invoceInformationCopy = { ...invoceInformation };
          invoceInformationCopy.invoice_number = auto_generated_invoice_number;
          setInvoiceInformation(invoceInformationCopy);
        }
      })
      .catch((error) => {
        alert("Error encounter");
        console.log(error);
      });
  };

  if (props.openInvoiceInformationReviewDialog == false) {
    return <div></div>;
  }

  function mainContent() {
    return (
      <React.Fragment>
        <div style={{ padding: ".25rem" }}>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={4} md={2} lg={2} className={classes.leftLabel}>
              Salesman Name
            </Grid>
            <Grid item xs={12} sm={8} md={10} lg={10} className={classes.rightLabel}>
              <TextField
                value={
                  selectedSalesman == null
                    ? ""
                    : `${selectedSalesman.first_name} ${selectedSalesman.last_name}`
                }
                variant="outlined"
                onClick={() => {
                  setOpenSalesmanDialog(true);
                }}
                InputProps={{
                  readOnly: true,
                }}
              />
            </Grid>
          </Grid>

          <Grid container spacing={1}>
            <Grid item xs={12} sm={4} md={2} lg={2} className={classes.leftLabel}>
              Invoice Number*
            </Grid>
            <Grid item xs={12} sm={8} md={10} lg={10} className={classes.rightLabel}>
              {autoGeneratedInvoiceNumber === "" ? (
                <TextField
                  variant="outlined"
                  onKeyDown={(e) => {
                    // Check if the key pressed is a digit, backspace, or delete
                    if (!(e.key === "Backspace" || e.key === "Delete" || /^\d$/.test(e.key))) {
                      e.preventDefault(); // Prevent the default action (typing the key)
                    }
                  }}
                  onChange={invoiceNumberInputOnChange}
                />
              ) : (
                <Typography variant="h6" gutterBottom>
                  {autoGeneratedInvoiceNumber}
                </Typography>
              )}
            </Grid>
          </Grid>

          <Grid container spacing={1}>
            <Grid item xs={12} sm={4} md={2} lg={2} className={classes.leftLabel}>
              Invoice Date*
            </Grid>
            <Grid item xs={12} sm={8} md={10} lg={10} className={classes.rightLabel}>
              <StyledEngineProvider injectFirst>
                <ThemeProvider theme={materialTheme}>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <MobileDatePicker
                      inputFormat="MMMM d, yyyy"
                      value={selectedInvoiceDate}
                      onChange={invoiceDateHandleDateChange}
                      renderInput={(params) => <TextField {...params} />}
                    />
                  </LocalizationProvider>
                </ThemeProvider>
              </StyledEngineProvider>
            </Grid>
          </Grid>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={4} md={2} lg={2} className={classes.leftLabel}>
              Scheduled Delivery Date*
            </Grid>
            <Grid item xs={12} sm={8} md={10} lg={10} className={classes.rightLabel}>
              <StyledEngineProvider injectFirst>
                <ThemeProvider theme={materialTheme}>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <MobileDatePicker
                      inputFormat="MMMM d, yyyy"
                      value={scheduleDeliveryDate}
                      onChange={scheduleDeliveryDateHandleDateChange}
                      renderInput={(params) => <TextField {...params} />}
                    />
                  </LocalizationProvider>
                </ThemeProvider>
              </StyledEngineProvider>
            </Grid>
          </Grid>

          <Grid container spacing={1}>
            <Grid item xs={4} sm={4} md={2} lg={2} className={classes.leftLabel}>
              Account Name:
            </Grid>
            <Grid item xs={8} sm={8} md={10} lg={10} className={classes.rightLabel}>
              <Typography variant="h6" gutterBottom>
                {props.selectedAccount.account_name}
              </Typography>
            </Grid>
          </Grid>
          <Grid container spacing={1}>
            <Grid item xs={4} sm={4} md={2} lg={2} className={classes.leftLabel}>
              Number of lines:
            </Grid>
            <Grid item xs={8} sm={8} md={10} lg={10} className={classes.rightLabel}>
              <Typography variant="h6" gutterBottom>
                {getTotalNumberOfLines()}
              </Typography>
            </Grid>
          </Grid>
          <Grid container spacing={1}>
            <Grid item xs={4} sm={4} md={2} lg={2} className={classes.leftLabel}>
              Invoice Value:
            </Grid>
            <Grid item xs={8} sm={8} md={10} lg={10} className={classes.rightLabel}>
              <Typography variant="h6" gutterBottom>
                {Number(totalInvoicedAmount).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </Typography>
            </Grid>
          </Grid>
        </div>

        <AppBar position="fixed" className={classes.appBarBottom}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              saveInvoice();
            }}
          >
            Finalize invoices
          </Button>
        </AppBar>
      </React.Fragment>
    );
  }
  return (
    <div>
      <Dialog
        fullScreen
        open={props.openInvoiceInformationReviewDialog}
        onClose={props.closeInvoiceInformationReviewDialogHandleClick}
        TransitionComponent={Transition}
      >
        <AppBar className={classes.appBar}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={props.closeInvoiceInformationReviewDialogHandleClick}
              size="large"
            >
              <CloseIcon />
            </IconButton>
            <Typography variant="h6" className={classes.title}>
              Invoice information review
            </Typography>
          </Toolbar>
        </AppBar>
        <div className={classes.appBarSpacer}></div>
        {isFecthingSalesman ? (
          <LinearProgress color="secondary" style={{ marginLeft: ".1rem", marginRight: ".1rem" }} />
        ) : (
          mainContent()
        )}
        {salesmanDialog(openSalesmanDialog, setOpenSalesmanDialog, salesmans, setSelectedSalesman)}
      </Dialog>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={materialTheme}>
          {messageDialog()}
          {progressDialog()}
        </ThemeProvider>
      </StyledEngineProvider>
    </div>
  );
}

export default InvoiceInformationReview;
